import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxProgressStepper from 'components/reusable/AdxProgressStepper'

import reportStatusConverter from '../services/helper/reportStatusConverter'

const ClaimProgressStepper = ({ reportData }) => {
  const data = {
    requestID: null,
    employeeID: reportData?.staff_id,
    employeeName: reportData?.staff_name,
    employeePicture: reportData?.staff_img,
    status: reportStatusConverter(reportData?.report_status?.name),
    submittedDate: reportData?.submitted_at,
    approvalRoute: reportData?.approval_stepper?.map((item) => {
      return {
        employeeName: item?.members,
        employeePicture: item?.profilePics,
        approvalStatus: item?.approvalStatus,
        approvedDate: item?.timestamp,
      }
    }),
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body1" color="text.quaternary">
        Progress
      </Typography>
      <AdxProgressStepper
        data={data}
        sxTextContainer={{ maxWidth: 250 }}
        lastActiveSubtitle="Reimbursed"
        lastInactiveSubtitle="Waiting reimbursement"
      />
    </Box>
  )
}

export default ClaimProgressStepper
